import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { templateParser } from '@fttb/common';
var setBlockAlias = function setBlockAlias(componentType, alias) {
  if (process.env.NODE_ENV === 'development' && hasBlockAlias(componentType)) {
    throw new Error('Переназначение alias блока запрещено.');
  }
  componentType.blockAlias = alias;
};
export var getBlockAlias = function getBlockAlias(componentType) {
  var blockAlias = componentType.blockAlias;
  if (process.env.NODE_ENV === 'development' && !blockAlias) {
    throw new Error('Компонент не помечен как блок, получение alias-а запрещено');
  }
  return blockAlias;
};
export var hasBlockAlias = function hasBlockAlias(componentType) {
  return !!componentType.blockAlias;
};

/**
 * Присваивает компоненту alias, не создает новую копию компонента
 * @param alias {string}
 */
export var defineBlock = function defineBlock(alias) {
  return function (WrappedComponent) {
    setBlockAlias(WrappedComponent, alias);
    return WrappedComponent;
  };
};
export var addOnClickForInfoCard = function addOnClickForInfoCard(cards, func) {
  return cards.map(function (card) {
    var _card$wrapperLink;
    if (card !== null && card !== void 0 && (_card$wrapperLink = card.wrapperLink) !== null && _card$wrapperLink !== void 0 && _card$wrapperLink.onClick) {
      return _objectSpread(_objectSpread({}, card), {}, {
        wrapperLink: {
          onClick: function onClick() {
            var _card$wrapperLink2;
            return func(card === null || card === void 0 ? void 0 : card.type, card === null || card === void 0 ? void 0 : card.title, card === null || card === void 0 || (_card$wrapperLink2 = card.wrapperLink) === null || _card$wrapperLink2 === void 0 ? void 0 : _card$wrapperLink2.href);
          }
        }
      });
    }
    return _objectSpread({}, card);
  });
};
export var cutTitleBlock = function cutTitleBlock(flag, title) {
  return flag ? title === null || title === void 0 ? void 0 : title.split(' ')[0] : title;
};
var generateFAQTabs = function generateFAQTabs(tabs, vars) {
  if (!tabs) return null;
  return tabs.map(function (tab) {
    var title = templateParser(tab.title, vars);
    var content = tab.content.map(function (el) {
      return el.map(function (item) {
        var text = templateParser(item.text, vars);
        return _objectSpread(_objectSpread({}, item), {}, {
          text: text
        });
      });
    });
    return _objectSpread(_objectSpread({}, tab), {}, {
      content: content,
      title: title
    });
  });
};
export var getNewItems = function getNewItems(_ref) {
  var items = _ref.items,
    region = _ref.region,
    regionin = _ref.regionin;
  var varsForTemplate = {
    region: region,
    regionin: regionin
  };
  return items.map(function (item) {
    var tabs = generateFAQTabs(item.tabs, varsForTemplate);
    return _objectSpread(_objectSpread({}, item), {}, {
      tabs: tabs
    });
  });
};
export var getTopPosition = function getTopPosition(refElement) {
  if (refElement) {
    var _refElement$getBoundi = refElement.getBoundingClientRect(),
      height = _refElement$getBoundi.height;
    return Math.floor(height / 2 - 40);
  }
  return 100;
};